import { Component, OnInit, OnDestroy, Renderer2, Inject } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs';

@Component({
  selector: 'app-blog-softwarereq-analysis',
  imports: [CommonModule, RouterModule],
  standalone: true,
  templateUrl: './blog-softwarereq-analysis.component.html',
  styleUrl: './blog-softwarereq-analysis.component.scss'
})
export class BlogSoftwarereqAnalysisComponent implements OnInit ,OnDestroy{
  constructor(private router: Router, private activatedRoute: ActivatedRoute,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private _document: Document
  ) { }
  private jsonLdScript: any;
  ngOnInit(): void {
    this.injectSchemaMarkup();
    this.router.events.pipe(
      filter((event: any) => event instanceof NavigationEnd),
      map(() => this.activatedRoute),
      map((route) => {
        while (route.firstChild) route = route.firstChild;
        return route;
      }),
      filter((route) => route.outlet === 'primary'),
      mergeMap((route: { data: any; }) => route.data)
    )
      .subscribe((event: any) => {
        if (this.router.url === '/blogs/software-requirement-analysis') {
          this.updateDescription(event.description, event.keywords, event.title);
        }
      });
  }
  ngOnDestroy(): void {
    this.removeSchemaMarkup();
  }
  injectSchemaMarkup(): void {
    const softwareReqSchema = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": "https://www.kalpitatechnologies.com/tech-blogs/software-requirement-analysis#webpage",
          "url": "https://www.kalpitatechnologies.com/tech-blogs/software-requirement-analysis",
          "name": "Comprehensive Guide to Software Requirement Analysis | Kalpita Technologies",
          "description": "Practical guide to software requirements analysis explaining what it is, why it matters, the analysis process, and key techniques.",
          "isPartOf": { "@id": "https://www.kalpitatechnologies.com/#website" },
          "inLanguage": "en",
          "datePublished": "2022-09-22"
        },
        {
          "@type": "BreadcrumbList",
          "@id": "https://www.kalpitatechnologies.com/tech-blogs/software-requirement-analysis#breadcrumb",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://www.kalpitatechnologies.com" },
            { "@type": "ListItem", "position": 2, "name": "Blog Index", "item": "https://www.kalpitatechnologies.com/tech-blogs/blog" },
            { "@type": "ListItem", "position": 3, "name": "Software Requirement Analysis", "item": "https://www.kalpitatechnologies.com/tech-blogs/software-requirement-analysis" }
          ]
        },
        {
          "@type": "BlogPosting",
          "@id": "https://www.kalpitatechnologies.com/tech-blogs/software-requirement-analysis#article",
          "headline": "Comprehensive Guide to Software Requirement Analysis",
          "articleBody": "If you are starting out or working on an existing software development project, you are well aware of how the requirement analysis phase dictates the journey of its completion...",
          "author": {
            "@type": "Organization",
            "name": "Kalpita Technologies BI Team"
          },
          "publisher": {
            "@type": "Organization",
            "name": "Kalpita Technologies",
            "logo": { "@type": "ImageObject", "url": "https://www.kalpitatechnologies.com/assets/common/black-logo.png" }
          },
          "datePublished": "2022-09-22",
          "image": "https://www.kalpitatechnologies.com/assets/resources/blog/software-reqanalysis/software-analyse.png"
        },
        {
          "@type": "FAQPage",
          "@id": "https://www.kalpitatechnologies.com/tech-blogs/software-requirement-analysis#faq",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "What is software requirements analysis?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Software requirements analysis is the process of understanding user and stakeholder needs and translating them into a set of quantifiable, relevant, and detailed product requirements."
              }
            }
          ]
        },
        {
          "@type": "Organization",
          "@id": "https://www.kalpitatechnologies.com/#organization",
          "name": "Kalpita Technologies",
          "url": "https://www.kalpitatechnologies.com/",
          "logo": { "@type": "ImageObject", "url": "https://www.kalpitatechnologies.com/assets/common/black-logo.png" }
        }
      ]
    };

    this.jsonLdScript = this.renderer.createElement('script');
    this.jsonLdScript.type = 'application/ld+json';
    this.jsonLdScript.text = JSON.stringify(softwareReqSchema);
    this.renderer.appendChild(this._document.head, this.jsonLdScript);
  }

  removeSchemaMarkup(): void {
    if (this.jsonLdScript) {
      this.renderer.removeChild(this._document.head, this.jsonLdScript);
      this.jsonLdScript = null;
    }
  }
  updateDescription(desc: string, keywords: string, title: string) {
    // this.seoService.updateDescription(desc);
    // this.seoService.updateMetaKeywords(keywords);
    // this.seoService.updateTitle(title);
  }

}
